export default "__VITE_ASSET__DaKYzuC1__"